import * as React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper' // Lisa EffectFade

import 'swiper/css'
import "swiper/css/navigation"
import 'swiper/css/pagination'
import 'swiper/css/effect-fade' // Lisa see CSS

SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade]);

const Slider = ({ items }) => {
  return (
    <Swiper
      className="mySwiper h-[500px] lg:h-[850px]"
      modules={[EffectFade]} // Veendu, et moodul on lisatud
      effect="fade"          // Aktiveeri fade efekt
      pagination={{ clickable: true }}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      speed={1000}
      loop={true}
    >
      {items.map((item, index) => (
        <SwiperSlide key={index} className="relative overflow-hidden">
          {/* Sisu jääb samaks */}
          <img
            src={item.image_mobile}
            alt={item.title}
            className="block md:hidden absolute inset-0 w-full h-full object-cover"
          />
          <img
            src={item.image}
            alt={item.title}
            className="hidden md:block absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex flex-col justify-center items-center z-10 bg-black/20">
            <div className="container mx-auto text-center text-white px-4">
              <h1 className="mb-6 text-h3 lg:text-hero font-bold" style={{textShadow: '1px 1px 4px rgba(0,0,0,0.8)'}}>
                {item.title}
              </h1>
              <p className="mb-14 text-basic lg:text-h3 min-h-8">
                {item.description}
              </p>
              <div className="flex flex-row justify-center gap-4 lg:gap-8">
                {item.btn1_text && <a href={item.btn1_url} className="primary-button">{item.btn1_text}</a>}
                {item.btn2_text && <a href={item.btn2_url} className="primary-button">{item.btn2_text}</a>}
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default Slider;
